import { useTranslation } from 'react-i18next';

import { Badge } from '@saas-kit/ui';

import type { Role } from './api';
import { RoleDeleteButton } from './RoleDeleteButton';

interface Props {
  isCreate: boolean;
  isSystem: boolean;
  canManage: boolean;
  role: Role | null;
  onDeleted: () => void;
  onError: (i18nKey: string) => void;
}

export function RoleEditorHeader({
  isCreate,
  isSystem,
  canManage,
  role,
  onDeleted,
  onError,
}: Props): JSX.Element {
  const { t } = useTranslation('rbac');

  return (
    <header className="flex flex-wrap items-start justify-between gap-3">
      <div>
        <div className="flex flex-wrap items-center gap-2">
          <h2 id="role-editor-title" className="text-lg font-semibold text-foreground">
            {isCreate ? t('editor.create_title') : (role?.name ?? '')}
          </h2>
          {role ? (
            <Badge variant={isSystem ? 'secondary' : 'outline'}>
              {t(isSystem ? 'list.kind_system' : 'list.kind_custom')}
            </Badge>
          ) : null}
        </div>
        {role && !isCreate ? (
          <p className="mt-1 font-mono text-xs text-muted-foreground">{role.slug}</p>
        ) : null}
        {isSystem ? (
          <p className="mt-1 text-xs text-muted-foreground">
            {t('editor.system_locked_note')}
          </p>
        ) : null}
      </div>
      {role && !isSystem && canManage ? (
        <RoleDeleteButton role={role} onDeleted={onDeleted} onError={onError} />
      ) : null}
    </header>
  );
}
